import { LineStyle } from 'lightweight-charts';
import { groupSignals, positionSignals } from './signalMarkerLayout';

export function installSignalOverlay({ chart, candles, host, bars, getSettings, onLayout }) {
  let lines = [], frame = null, stopped = false, previous = '', lastSize = '';
  const barsByTime = new Map(bars.map(bar => [bar.time, bar]));
  function update() {
    frame = null;
    if (stopped) return;
    const settings = getSettings();
    const next = positionSignals(settings.showSignals ? groupSignals(settings.signals) : [], barsByTime, chart, candles, host);
    const serialized = JSON.stringify(next);
    if (serialized !== previous) { previous = serialized; onLayout(next); }
  }
  const schedule = () => { if (!stopped && frame === null) frame = requestAnimationFrame(update); };
  const primitive = { updateAllViews: schedule, paneViews: () => [] };
  candles.attachPrimitive(primitive);
  chart.timeScale().subscribeVisibleLogicalRangeChange(schedule);
  chart.timeScale().subscribeSizeChange(schedule);
  const resizeObserver = new ResizeObserver(() => {
    const size = `${host.clientWidth}:${host.clientHeight}`;
    if (!stopped && size !== lastSize) { lastSize = size; chart.timeScale().fitContent(); schedule(); }
  });
  resizeObserver.observe(host);
  const autoscale = original => {
    const info = original(), prices = getSettings().levels.map(level => level.price);
    if (!info || !prices.length) return info;
    return { ...info, priceRange: { minValue: Math.min(info.priceRange.minValue, ...prices), maxValue: Math.max(info.priceRange.maxValue, ...prices) } };
  };
  return {
    refresh() {
      lines.forEach(line => candles.removePriceLine(line));
      lines = getSettings().levels.map(level => candles.createPriceLine({ price: level.price, color: level.color,
        lineWidth: 2, lineStyle: level.action === 'entry' ? LineStyle.Dashed : LineStyle.Dotted, axisLabelVisible: false, title: '' }));
      candles.applyOptions({ autoscaleInfoProvider: autoscale });
      schedule();
    },
    destroy() {
      stopped = true; resizeObserver.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      chart.timeScale().unsubscribeVisibleLogicalRangeChange(schedule);
      chart.timeScale().unsubscribeSizeChange(schedule);
      candles.detachPrimitive(primitive);
    },
  };
}